import React, { FC, Fragment, useContext, useState } from "react";
import StorySentence from "Components/StorySentence";
import { SentenceTaskProps } from "./SentenceTask.type";
import { Button, Modal, Space } from "antd";
import { STATIC_URL } from "App.constants";
import { TaskType } from "App.types";
import ScrollerTask from "./ScrollerTask";
import { isMobile } from "react-device-detect";
import { AudioOutlined } from "@ant-design/icons";
import TaskPanelBasic from "Components/TaskPanelBasic";
import styles from "./SentenceTask.module.scss";
import cx from "classnames";
import useSentencesAudios from "Hooks/useSentencesAudios";
import { replaceTemplates } from "App.helpers";
import { UserContext } from "App";
import { useSuspenseQuery } from "@tanstack/react-query";
import API from "Api";

const IntroTask: FC<SentenceTaskProps> = ({ sentence: taskSentence, lesson, completeLesson, onTaskComplete, onNext }) => {
  const [confirmModal, setConfirmModal] = useState(false);
  const [selectTypeModal, setSelectTypeModal] = useState(false);
  const [activeType, setActiveType] = useState<TaskType>();

  const { sentences = [], id: storyId } = taskSentence.linkedStory || {};

  const audios = useSentencesAudios({ sentences });

  const user = useContext(UserContext);

  const { data: userProps } = useSuspenseQuery({
    queryKey: ["props", user?.id],
    queryFn: API.user.getProps,
    staleTime: Infinity,
  });

  return (
    <div>
      {!activeType && (
        <div className={cx(styles.intro, { [styles.intro__mobile]: isMobile })}>
          <div
            className={styles.intro__title}
            dangerouslySetInnerHTML={{ __html: replaceTemplates(taskSentence.description ?? "", userProps) }}
          />

          <div dangerouslySetInnerHTML={{ __html: taskSentence.grammar?.content ?? "" }} />
          {sentences.map((sentence, idx) => (
            <Fragment key={sentence.id}>
              <StorySentence showTranslate={true} storyId={storyId} sentence={sentence} audio={audios?.[idx]} />
              <div />
            </Fragment>
          ))}
        </div>
      )}

      {!activeType && (
        <TaskPanelBasic justify={"center"}>
          <Space>
            <Button type={"link"} shape={"round"} onClick={() => setConfirmModal(true)}>
              skip lesson
            </Button>
            <Button type={"primary"} shape={"round"} onClick={() => onTaskComplete().then(() => onNext())}>
              Let's go!
            </Button>
          </Space>
        </TaskPanelBasic>
      )}

      <Modal
        open={confirmModal}
        onOk={() => setConfirmModal(false)}
        onCancel={() => {
          setConfirmModal(false);
          setSelectTypeModal(true);
        }}
        title={"Уже знаешь как переводятся эти слова и предложения и готов подтвердить свои знания?"}
        okText={"Вернуться в урок"}
        cancelText={"Да, я уже все это знаю"}
      >
        <img src={`${STATIC_URL}/covers/man_finish.svg`} alt={""} />
      </Modal>

      <Modal
        onCancel={() => setSelectTypeModal(false)}
        open={selectTypeModal}
        title={"Готов переводить голосом?"}
        footer={
          <Space direction={isMobile ? "vertical" : "horizontal"}>
            <Button onClick={() => setSelectTypeModal(false)} type={"primary"}>
              Вернуться в урок
            </Button>
            <Button
              onClick={() => {
                setSelectTypeModal(false);
                setActiveType(TaskType.Translate);
              }}
            >
              Нет, буду печатать
            </Button>
            <Button
              danger
              icon={<AudioOutlined />}
              onClick={() => {
                setSelectTypeModal(false);
                setActiveType(TaskType.VoiceTranslate);
              }}
            >
              Да
            </Button>
          </Space>
        }
      >
        <img src={`${STATIC_URL}/covers/speak.svg`} alt={""} />
      </Modal>

      {activeType && (
        <ScrollerTask
          sentence={taskSentence}
          activeType={activeType}
          backToLesson={() => setActiveType(undefined)}
          onTaskComplete={() =>
            new Promise(() => {
              setActiveType(undefined);
              completeLesson?.();
            })
          }
          lesson={lesson}
          onNext={() => {}}
          setTry={() => {}}
          setDictOpened={() => {}}
        />
      )}
      <div style={{ height: 60 }} />
    </div>
  );
};

export default IntroTask;
